import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RowBody } from "../../../../components/RowValue/RowBody";
import { selectSelectedCarryingElement } from "../../../../store/slices/fhwaSlice";
import DesignLoadSelection from "./DesignLoadSelection";

function SelectedLoadCarryingElement({ readOnly = false }) {
  const { t } = useTranslation("translation");
  const carryingElement = useSelector(selectSelectedCarryingElement);

  function renderInput() {
    if (readOnly) {
      return <span className="input">{carryingElement.name}</span>;
    } else {
      return <DesignLoadSelection />;
    }
  }

  return (
    <RowBody
      titleValue={<p>{t("aashto.inner.Selected Load Carrying Element")}</p>}
      inputValue={renderInput()}
    />
  );
}

export default SelectedLoadCarryingElement;
